import { useLanguageContext } from "../../context/LanguageContext";
import AttendanceListPage from "../../pages/attendance_list/AttendanceListPage";
import useAttendanceListRouteValidator from "../validators/AttendanceListRouteValidator";
import { RouteConfig } from "./RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAttendanceListRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/attendance_list")
    .setLabel(translate("eva.main.entities.attendance_list"))
    .setValidator(useAttendanceListRouteValidator())
    .setPage(<AttendanceListPage />);
}

export default useAttendanceListRouteConfig;
